export default import.meta.ROLLUP_FILE_URL_Spc6BW0DeuqIXouFiOsDBQ